import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DataService } from 'src/app/shared/service/data.service';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormArray, FormControl } from '@angular/forms';
import { formatDate } from '@angular/common';
import { SharedService } from 'src/app/shared/service/shared.service';
import { SKUList, SKUShiftList } from '../../model/machine-layout.model';
import { takeUntil } from 'rxjs/operators';
import { Subject, SubscribableOrPromise, Subscription } from 'rxjs';

@Component({
  selector: 'app-manual-entry-popup',
  templateUrl: './manual-entry-popup.component.html',
  styleUrls: ['./manual-entry-popup.component.scss']
})
export class ManualEntryPopupComponent implements OnInit, OnDestroy {
  disableSave: boolean;
  manualServiceCall = true;
  currentDate: any;
  minimumDate: any;
  maximumDate: any;
  selectedDate: any;
  isUpdate = false;

  multiShiftDetails: UntypedFormGroup;
  shiftList: SKUShiftList[];
  shiftAllList: SKUShiftList[];
  skuList: SKUList[];
  localStorageData: any;

  setManualEntrySubscription: Subscription;
  getShiftListForManualEntrySubscription: Subscription;

  constructor(
    @Inject(MAT_DIALOG_DATA) public shiftMachineData,
    private dialog: MatDialogRef<ManualEntryPopupComponent>,
    private dataSer: DataService,
    public formBuilder: UntypedFormBuilder,
    private service: SharedService) { }

  ngOnInit() {
    this.disableSave = false;
    this.currentDate = new Date();
    this.minimumDate = new Date(2021, 2);
    this.maximumDate = this.currentDate;
    this.shiftList = [];
    this.shiftAllList = [];
    this.skuList = [];

    this.multiShiftDetails = this.formBuilder.group({
      datePickerValue: [{ value: this.currentDate, disabled: true }, Validators.required],
      shiftArray: this.formBuilder.array([])
    });

    this.localStorageData = JSON.parse(sessionStorage.getItem('caivanoDashboard')) ?
      JSON.parse(sessionStorage.getItem('caivanoDashboard')) : null;
    // if (this.shiftMachineData.shiftIndex === 3) {
    //   this.selectedDate = formatDate(this.currentDate.setDate(this.currentDate.getDate() - 1), 'yyyy-MM-dd', 'en');
    // } else {
    this.selectedDate = formatDate(this.currentDate, 'yyyy-MM-dd', 'en');
    // }
    this.getShift(this.currentDate);
  }


  dialogClose() {
    this.dialog.close();
  }

  saveClicked() {
    const tempDateRaw = this.multiShiftDetails.get('datePickerValue').value.toString();
    const tempDate = new Date(tempDateRaw);
    const tempNCWaste = [];
    (this.multiShiftDetails.get('shiftArray') as UntypedFormArray).controls.forEach((shiftArrayValue: UntypedFormGroup) => {
      tempNCWaste.push({
        skuId: shiftArrayValue.get('sku').value ? shiftArrayValue.get('sku').value : null,
        skuName: this.getSKUName(shiftArrayValue.get('skuList').value, shiftArrayValue.get('sku').value) ?
          this.getSKUName(shiftArrayValue.get('skuList').value, shiftArrayValue.get('sku').value) : null,
        ShiftNumber: shiftArrayValue.get('shift').value && shiftArrayValue.get('shift').value.shiftNumber ?
          shiftArrayValue.get('shift').value.shiftNumber.toString() : null,
        // ShiftStartTime: shiftArrayValue.get('shift').value && shiftArrayValue.get('shift').value.starDateTimeConverted ?
        //   shiftArrayValue.get('shift').value.starDateTimeConverted : null,
        // ShiftEndTime: shiftArrayValue.get('shift').value && shiftArrayValue.get('shift').value.endDateTimeConverted ?
        //   shiftArrayValue.get('shift').value.endDateTimeConverted : null,
        ShiftStartTime: this.shiftMachineData.masterShiftStartTime,
        ShiftEndTime: this.shiftMachineData.masterShiftEndTime,
        Quantity: shiftArrayValue.get('actualValue').value || shiftArrayValue.get('actualValue').value === 0 ?
          Number(shiftArrayValue.get('actualValue').value) : null,
        ActualPercent: shiftArrayValue.get('actualPercentage').value || shiftArrayValue.get('actualPercentage').value === 0 ?
          Number(shiftArrayValue.get('actualPercentage').value) : null
      });
    });

    const fromDate = new Date(Date.UTC(tempDate.getFullYear(), tempDate.getMonth(),
      tempDate.getDate(), 0, 0, 0)).toISOString().split('.')[0] + 'Z';
    const toDate = new Date(Date.UTC(tempDate.getFullYear(), tempDate.getMonth(),
      tempDate.getDate(), 23, 59, 59)).toISOString().split('.')[0] + 'Z';

    const requestParameters = {
      ClusterId: this.localStorageData && this.localStorageData.cluster && this.localStorageData.cluster.id ?
        this.localStorageData.cluster.id : null,
      FactoryId: this.localStorageData && this.localStorageData.factory && this.localStorageData.factory.id ?
        this.localStorageData.factory.id : null,
      LineId: this.localStorageData && this.localStorageData.line && this.localStorageData.line.id ?
        this.localStorageData.line.id : null,
      MachineId: this.shiftMachineData && this.shiftMachineData.popupData && this.shiftMachineData.popupData.id ?
        this.shiftMachineData.popupData.id : null,
      FromDate: fromDate ? fromDate : null,
      ToDate: toDate ? toDate : null,
      NCWaste: tempNCWaste
    };

    this.setManualEntrySubscription = this.service.setManualEntry(requestParameters)
      .subscribe((data: any) => {

        this.dialog.close('saved');

      });
  }

  getSKUName(skuArray: any, skuNameString: string) {
    try {
      let skuName = null;

      if (skuArray && skuArray.length > 0 &&
        skuArray.filter(list => list.skuName === skuNameString)[0]) {

        skuName = skuArray.filter(list => list.skuName === skuNameString)[0].skuDescription;
      }

      return skuName;
    } catch (error) {

    }
  }

  setMultiShiftDetails() {
    return this.formBuilder.group({
      shift: ['', Validators.required],
      sku: ['', Validators.required],
      skuList: this.formBuilder.array([]),
      actualValue: '',
      actualPercentage: ''
    });
  }

  addShift() {
    (this.multiShiftDetails.controls.shiftArray as UntypedFormArray).push(this.setMultiShiftDetails());
  }

  get shiftValue(): UntypedFormArray {
    return this.multiShiftDetails.get('shiftArray') as UntypedFormArray;
  }

  getSKUArray(index: number): UntypedFormArray {
    return this.shiftValue.controls[index].get('skuList') as UntypedFormArray;
  }

  removeShift(index: number) {
    (this.multiShiftDetails.controls.shiftArray as UntypedFormArray).removeAt(index);
  }

  onShiftChange(index: number) {

    while (this.getSKUArray(index).length !== 0) {
      this.getSKUArray(index).removeAt(0);
    }

    this.shiftValue.controls[index].get('sku').setValue('');

    const selectedShiftList: SKUShiftList[] = this.shiftList.filter(shiftFiltr =>
      shiftFiltr.shiftName === this.shiftValue.controls[index].value.shift.shiftName);

    if (selectedShiftList && selectedShiftList[0]) {

      selectedShiftList[0].skus.forEach(skuElement => {
        const skuFormGroup: UntypedFormGroup = this.formBuilder.group({
          skuKey: skuElement.skuKey,
          skuName: skuElement.skuName,
          skuDescription: skuElement.skuDescription,
          isSKUSelected: false
        });
        // this.shiftValue.controls[index].get('sku').setErrors(null);
        this.getSKUArray(index).push(skuFormGroup);

      });
    }

    // if (this.shiftValue.value.filter(shValue => shValue.shift.shiftName === selectedShiftList[0].shiftName).length > 1) {
    //    this.shiftValue.controls[index].get('shift').setErrors({ duplicate: true });
    // } else {
    // }


  }

  onSkuChange(sku: SKUList, index: number) {

    const selectedShift: string = this.shiftValue.controls[index].get('shift').value.shiftName;

    if ((this.shiftValue as UntypedFormArray).controls.filter((shiftForm: UntypedFormGroup) =>
      shiftForm.get('shift').value.shiftName === selectedShift && shiftForm.get('sku').value === sku) &&
      (this.shiftValue as UntypedFormArray).controls.filter((shiftForm: UntypedFormGroup) =>
        shiftForm.get('shift').value.shiftName === selectedShift && shiftForm.get('sku').value === sku).length > 1) {

      this.shiftValue.controls[index].get('sku').setErrors({ duplicate: true });

    }

  }

  checkNumberOnly(event: any, index: any, inputField: any): boolean {

    const charCode = (event.which) ? event.which : event.keyCode;

    if (inputField === 'actualPercentage' && event && event.target && event.target.value &&
      event.target.value !== '' && event.target.value.indexOf('.') > -1 &&
      event.target.value.split('.')[1] && event.target.value.split('.')[1].length > 0) {
      return false;
    }

    if (inputField === 'actualValue' && charCode !== 43 && charCode !== 45 && charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }

    if ((charCode === 43 || charCode === 45)) {
      if (inputField === 'actualValue') {
        if (!this.multiShiftDetails.get('shiftArray').value[index].actualValue) {
          return true;
        } else {
          return false;
        }
      } else if (inputField === 'actualPercentage') {
        if (!this.multiShiftDetails.get('shiftArray').value[index].actualPercentage) {
          return true;
        } else {
          return false;
        }
      }
    } else {
      return true;
    }
  }

  dateSelected() {
    this.selectedDate = formatDate(this.multiShiftDetails.get('datePickerValue').value, 'yyyy-MM-dd', 'en');
    this.getShift(this.multiShiftDetails.get('datePickerValue').value, 'dateSelected');
  }

  getShift(date: any, type?: string) {
    this.manualServiceCall = false;
    if (this.localStorageData.factory.id.$oid) {
      this.localStorageData.factory.id = this.localStorageData.factory.id.$oid;
    } else {
      this.localStorageData.factory.id = this.localStorageData.factory.id;
    }
    this.getShiftListForManualEntrySubscription = this.service.getShiftListForManualEntry(this.localStorageData, formatDate(date, 'yyyy-MM-dd', 'en'))
      .subscribe(res => {
        this.manualServiceCall = true;
        if (res && res.result && res.result.length > 0) {
          this.shiftList = res.result;
          this.shiftValue.controls.forEach((element, index) => {
            this.shiftValue.controls[index].get('sku').reset();

            while (this.getSKUArray(index).length !== 0) {
              this.getSKUArray(index).removeAt(0);
            }

          });
          this.shiftList.forEach((singleShift: SKUShiftList, index: number) => {
            if (this.shiftMachineData && this.shiftMachineData.masterShiftList &&
              this.shiftMachineData.masterShiftList[index] && singleShift) {
              singleShift.masterShiftData = this.shiftMachineData.masterShiftList[index];
            }
          });

          this.formartShiftTime();

          if (this.shiftMachineData && this.shiftMachineData.popupData && this.shiftMachineData.popupData.skuWasteShift &&
            this.shiftMachineData.popupData.skuWasteShift.length > 0) {

            this.isUpdate = true;
            this.updateDataIntoForm(this.shiftMachineData.popupData.skuWasteShift);
          } else if (!type || type !== 'dateSelected') {

            this.addShift();
          }
        } else {
          this.shiftList = [];
        }
      }, err => {
        this.manualServiceCall = true;
      });
  }

  formartShiftTime() {
    if (this.shiftMachineData && this.shiftMachineData.timeZone && this.shiftMachineData.timeZoneArea) {

      this.shiftList.forEach((shift: SKUShiftList, index: any) => {
        shift.shiftName = 'Shift ' + (index + 1);
        shift.shiftNumber = index + 1;

        const moment = require('moment-timezone');
        const masterStart = moment.tz(this.shiftMachineData.timeZone.substring(0, 11) + shift.masterShiftData.shiftStart,
          this.shiftMachineData.timeZoneArea).utc().format();
        let masterEnd = moment.tz(this.shiftMachineData.timeZone.substring(0, 11) + shift.masterShiftData.shiftEnd,
          this.shiftMachineData.timeZoneArea).utc().format();

        if (shift.masterShiftData.shiftStart > shift.masterShiftData.shiftEnd) {
          masterEnd = moment.tz(this.shiftMachineData.timeZone.substring(0, 11) + shift.masterShiftData.shiftEnd,
            this.shiftMachineData.timeZoneArea).add('days', 1).utc().format();
        }

        shift.starDateTimeConverted = masterStart.split('.')[0];
        shift.endDateTimeConverted = masterEnd.split('.')[0];
      });

      this.shiftAllList = this.shiftList;

      if (this.shiftMachineData.shiftIndex && this.selectedDate &&
        (this.selectedDate === formatDate(new Date(), 'yyyy-MM-dd', 'en'))) {
        this.shiftList = this.shiftList.filter((shift: SKUShiftList) =>
          Number(shift.shiftNumber) <= Number(this.shiftMachineData.shiftIndex)
        );
      }

    }
  }

  updateDataIntoForm(skuWasteShift) {
    try {

      while (this.shiftValue.length !== 0) {
        this.shiftValue.removeAt(0);
      }

      skuWasteShift.forEach(shiftData => {

        const oldShiftData: UntypedFormGroup = this.formBuilder.group({
          shift: [{
            value: this.shiftList.filter(shList =>
              Number(shList.shiftNumber) === Number(shiftData.shiftNumber))[0], disabled: true
          }, Validators.required],
          sku: [{ value: '', disabled: true }, Validators.required],
          skuList: this.getSKUListArray(this.shiftList.filter(shList =>
            Number(shList.shiftNumber) === Number(shiftData.shiftNumber))[0].skus.filter(skuList => skuList.skuName === shiftData.sku)),
          actualValue: shiftData.quantity,
          actualPercentage: shiftData.actualPercent
        });

        oldShiftData.get('sku').setValue((oldShiftData.get('skuList') as UntypedFormArray).controls[0].value.skuName);
        (this.multiShiftDetails.controls.shiftArray as UntypedFormArray).push(oldShiftData);

      });

    } catch (error) {

    }
  }

  getSKUListArray(skuList): UntypedFormArray {
    try {

      const formBuilder: UntypedFormArray = this.formBuilder.array([]);

      if (skuList && skuList.length > 0) {

        skuList.forEach(skuListObj => {

          const skuForm: UntypedFormGroup = this.formBuilder.group({
            skuKey: skuListObj.skuKey,
            skuName: skuListObj.skuName,
            skuDescription: skuListObj.skuDescription
          });

          formBuilder.controls.push(skuForm);
        });

        return formBuilder;
      }


    } catch (error) {

    }
  }

  ngOnDestroy(): void {
    if (this.setManualEntrySubscription) {
      this.setManualEntrySubscription.unsubscribe();
    }
    if (this.getShiftListForManualEntrySubscription) {
      this.getShiftListForManualEntrySubscription.unsubscribe();
    }
  }

}
